import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const appParams = window.appData ? window.appData : {} ;
ReactDOM.render(
  <React.StrictMode>
    <App appParams={appParams} />
  </React.StrictMode>,
  document.getElementById('member-search-app')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
